import axiosInstance, { API_BASE_URL } from "../config/API";
import axios from "axios";

const API_ENDPOINT = '/craft_design.php';

// Fetch all craft designs
export const fetchCraftDesignsApi = async (searchText = "") => {
  try {
    const payload = {
      action: "listCraftDesigns",
      search_text: searchText,
    };
    const response = await axiosInstance.post(API_ENDPOINT, payload);
    const data = response.data;
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.body?.designs)) return data.body.designs;
    if (Array.isArray(data?.designs)) return data.designs;
    if (Array.isArray(data?.data)) return data.data;
    if (Array.isArray(data?.body)) return data.body;
    return [];
  } catch (err) {
    console.error("Error fetching craft designs:", err);
    return [];
  }
};

// Fetch single craft design by ID
export const getCraftDesignByIdApi = async (id) => {
  const payload = {
    action: "getCraftDesign",
    id: id,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  return response.data?.body?.design || null;
};

// Add new craft design
export const addCraftDesignApi = async (designData) => {
  const payload = {
    action: "addCraftDesign",
    ...designData,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  return response.data;
};

// Update existing craft design
export const updateCraftDesignApi = async (designData) => {
  const payload = {
    action: "updateCraftDesign",
    ...designData,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  return response.data;
};

// Delete craft design by ID (soft delete)
export const deleteCraftDesignApi = async (id) => {
  const payload = {
    action: "deleteCraftDesign",
    id: id,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  return response.data;
};

// Upload file (multipart form data with client/server compression)
export const uploadCraftDesignFileApi = async (file, type = 'image') => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("type", type);

  const uploadUrl = `${API_BASE_URL}${API_ENDPOINT}`;
  const response = await axios.post(uploadUrl, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data?.body;
};

// Fetch Excel ArrayBuffer from server (with fail-safe base64 fallback)
export const fetchCraftDesignExcelApi = async (filepath) => {
  if (!filepath) throw new Error("Filepath is empty");

  // Method 1: Try direct GET request using API_BASE_URL
  try {
    const cleanPath = filepath.startsWith("http")
      ? filepath
      : `${API_BASE_URL.replace(/\/api\/?$/, "")}/${filepath.replace(/^\/+/, "")}`;

    const response = await axios.get(cleanPath, { responseType: "arraybuffer" });
    if (response.data && response.data.byteLength > 0) {
      return response.data;
    }
  } catch (err) {
    console.warn("Direct GET excel fetch failed, falling back to base64 API:", err.message);
  }

  // Method 2: Fail-safe fallback via PHP getExcelBase64 API
  const payload = {
    action: "getExcelBase64",
    filepath: filepath,
  };
  const res = await axiosInstance.post(API_ENDPOINT, payload);
  if (res.data?.body?.base64) {
    const binaryString = atob(res.data.body.base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }

  throw new Error("Unable to retrieve Excel file from server");
};
